<template>
  <div class="top-container" :class="{'nav-en': $t('lang') === 'En','bgTran':$route.path === '/'}">
    <nav class="navbar">
      <img class="logo-container" src="../assets/nav-logo.png" />
      <ul class="nav-links">
        <li
          v-for="item in navItems"
          :key="item.path"
          :class="{
            actived: $route.path === item.path,
            'nav-en': $t('lang') === 'En',
          }"
        >
          <router-link :to="item.path">
            {{ item.name }}
          </router-link>
        </li>
        <li class="language-toggle" @click="toggleLanguage">
          <img src="../assets/earth.png" width="20px">
          {{$t('lang') === 'En'? 'Zh':'En'}}
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      currentLanguage: "zh",
      navItems: [
        { path: "/", name: this.$t("home") },
        { path: "/news", name: this.$t("news") },
        { path: "/fullDuplex", name: this.$t("full_duplex") },
        { path: "/medical", name: this.$t("medical") },
        { path: "/verification", name: this.$t("verification") },
        { path: "/research", name: this.$t("research") },
        { path: "/standards", name: this.$t("standards") },
        { path: "/about", name: this.$t("about") },
        { path: "/lectures", name: this.$t("lectures") },
      ],
    };
  },
  methods: {
    toggleLanguage() {
      const lang = this.$t("lang") === "En" ? "zh" : "en";
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      this.$router.go(0);
    },
  },
};
</script>

<style scoped lang="scss">
.top-container {
  position: fixed;
  top: 0;
  background: #063793;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: flex-end;
  z-index: 1000;
  &.bgTran {
    background: transparent;
  }
  &.nav-en{
    li {
      margin: 0 0.3vw;
      font-size: 15px;
    }
    .logo-container {
      width: 28%;
    }
  } 
}
.navbar {
  color: white;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 5vw;
  box-sizing: border-box;

  font-weight: 300;
  font-size: 15px;
  color: #fefefe;
}
.logo-container {
  width: 38%;
}
.nav-links {
  display: flex;
  align-items: center;
}
.nav-links li {
  margin: 0 0.8vw;
  cursor: pointer;
  line-height: 1;
  position: relative;
  
}
.actived {
  font-weight: 600;
  &::before {
    content: "";
    width: 20px;
    height: 5px;
    background: #920307;
    position: absolute;
    left: calc(50% - 10px);
    bottom: -10px;
  }
}
.language-toggle {
  display: flex;
  align-items: center;
  font-weight: 500;
  img {
    margin-right: 6px;
  }
}
</style>    